import React from 'react';
import './ProfileSelector.css';

const ProfileSelector = ({
    profiles,
    useProfile,
    selectedProfileId,
    onUseProfileChange,
    onProfileChange
}) => {
    return (
        <div className="profile-selector">
            <h2>Personalize Your Theme</h2>
            <p>Use your business profile to pre-fill the theme with your information</p>

            <div className="profile-options">
                <label className="radio-option">
                    <input
                        type="radio"
                        checked={!useProfile}
                        onChange={() => onUseProfileChange(false)}
                    />
                    <div className="option-content">
                        <strong>Use Placeholders</strong>
                        <p>Theme will use generic placeholder text (you'll edit later)</p>
                    </div>
                </label>

                <label className="radio-option">
                    <input
                        type="radio"
                        checked={useProfile}
                        onChange={() => onUseProfileChange(true)}
                        disabled={profiles.length === 0}
                    />
                    <div className="option-content">
                        <strong>Use Business Profile</strong>
                        <p>Theme will include your business information</p>

                        {useProfile && profiles.length > 0 && (
                            <select
                                value={selectedProfileId || ''}
                                onChange={(e) => onProfileChange(e.target.value)}
                                className="profile-dropdown"
                            >
                                <option value="">Select a profile...</option>
                                {profiles.map(profile => (
                                    <option key={profile.id} value={profile.id}>
                                        {profile.business_name}
                                        {profile.is_default ? ' (Default)' : ''}
                                    </option>
                                ))}
                            </select>
                        )}

                        {profiles.length === 0 && (
                            <p className="no-profiles">
                                No profiles yet. <a href="/profile/create?returnTo=generator">Create one now</a>
                            </p>
                        )}
                    </div>
                </label>
            </div>

            {useProfile && selectedProfileId && (
                <div className="profile-preview">
                    {(() => {
                        const profile = profiles.find(p => String(p.id) === String(selectedProfileId));
                        return profile ? (
                            <div className="preview-card">
                                <h4>Preview: {profile.business_name}</h4>
                                <p>Email: {profile.email}</p>
                                <p>Services: {profile.service_count || 0}</p>
                            </div>
                        ) : null;
                    })()}
                </div>
            )}
        </div>
    );
};

export default ProfileSelector;
